import { useCallback, useEffect, useState } from "react";

import { fetchBranchUsage } from "../services/branchService";

/**
 * The plan's active-branch usage — `{ branches_active_limit, branches_active_count }`,
 * the limit null when unlimited. Null until loaded, and left null when the call
 * fails: nothing is locked on a guess, the API still refuses an activation past
 * the limit with a 422 on `status`.
 *
 * `reload` re-reads it after a save that may have changed the count.
 */
export default function useBranchUsage(enabled = true) {
  const [usage, setUsage] = useState(null);

  const reload = useCallback(async () => {
    try {
      setUsage(await fetchBranchUsage());
    } catch {
      setUsage(null);
    }
  }, []);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  return { usage, reload };
}
